export default __webpack_public_path__ + "static/media/main-img.7e6257e5.svg";